// extracted by mini-css-extract-plugin
module.exports = {"appRatings":"styles__appRatings___PPwIi","appStoreRating":"styles__appStoreRating___2OYsY"};